// Please include all 2/3 legal texts here as they are subject to changes

export const legalTextSea50K = (
  <>
    0,68 % Zinsen: 2/3 aller Kunden erhalten: Nettodarlehensbetrag 50.000,00 €,
    60 Monate Laufzeit, 8,70 % effektiver Jahreszins, 8,37 % p.a. gebundener
    Sollzins, 60 mtl. Raten zu je 1.022,73 €, 61.363,57 € Gesamtbetrag,
    Vereinigte Volksbank Raiffeisenbank eG, Darmstädter Str. 62, 64354
    Reinheim.(§17 PAngV)
  </>
);

export const legalTextSeaMinusInterest1KStr =
  'Alle Kunden erhalten: bei 1.000 € Nettodarlehensbetrag, 24 Monate Laufzeit, -0,40% effektiver Jahreszins, -0,40% p.a. gebundener Sollzins, 23 mtl. Raten zu je 41,67 und eine Schlussrate zu 41,59 €, 995,50 € Gesamtbetrag, Vereinigte Volksbank Raiffeisenbank eG, Darmstädter Str. 62, 64354 Reinheim. Der Zinssatz von -0,40% ergibt sich durch eine einmalige Ausgleichszahlung.';
